<div class="min-h-screen w-full flex flex-col">
  <app-header></app-header>
  <app-toolbar></app-toolbar>
  <app-submenu [items]="subMenuItems"></app-submenu>
  <div class="grid grid-cols-12 h-full px-7 flex-1" style="grid-template-rows: 1fr;">
    <div class="col-span-12 lg:col-span-3 border-r-2 border-slate-500 p-3 min-h-[300px] relative">
      <p class="font-extrabold text-xl ">Items:</p>
      <hr class="mt-2 border-2 mb-2">
      <div class="flex flex-row flex-wrap items-start gap-2 w-full" *ngIf="billables.length > 0">
        <div *ngFor="let item of billables; let i = index"
          class="hover:cursor-pointer hover:bg-cyan-700 billable-item h-24 w-24 bg-gray-700 border border-blue-400 flex justify-center items-center self-start"
          (click)="handleBillable(i, item)">
          <h3 class="text-white text- small-caps text-center small-caps text-sm">{{item[0].name}}</h3>
        </div>
        <div
          class="hover:cursor-pointer hover:bg-cyan-700 billable-item h-24 w-24 bg-orange-700 border border-blue-400 flex justify-center items-center self-start"
          (click)="handleOthers()">
          <h3 class="text-white text- small-caps text-center small-caps text-sm">OTROS</h3>
        </div>
        <button
          class="hover:cursor-pointer hover:bg-cyan-700 billable-item h-24 w-24 bg-orange-700 border border-blue-400 flex justify-center items-center self-start disabled:opacity-65"
          (click)="handleBooking()" [disabled]="isPayBookingCash">
          <h3 class="text-white text- small-caps text-center small-caps text-sm">Reserva</h3>
        </button>
      </div>
      <ng-container *ngIf="toggleActividadesFlag">
        <p class="font-extrabold text-xl mt-10">Actividades:</p>
        <hr class="mt-2 border-2 mb-2">
        <table *ngIf="selectedBookings[indexBooking] && selectedBookings[indexBooking].services.length > 0"
          class="w-full border-collapse border border-gray-200 text-left text-xs mt-2 p-datatable-striped p-datatable-sm">
          <thead class="bg-gray-200">
            <tr>
              <th class="border border-gray-300 px-4 py-1">Actividad</th>
              <th class="border border-gray-300 px-4 py-1">Fecha y hora</th>
              <th class="border border-gray-300 px-4 py-1">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngIf="selectedBookings[indexBooking] && selectedBookings[indexBooking].services.length > 0; ">
              <tr *ngFor="let bookservice of selectedBookings[indexBooking].services; let i = index;">
                <td class="border border-gray-300 px-4 py-1">
                  {{ getServiceName(bookservice.service_profile_id) }}<br>
                  <b>({{ bookservice.units}}x)</b> {{ bookservice.service_profile?.name}}
                </td>
                <td class="border border-gray-300 px-4 py-1">
                  {{bookservice.date}} {{bookservice.hour}}
                </td>
                <td class="border border-gray-300 px-4 py-1 text-base text-right font-bold text-red-700">
                  {{ bookservice.unit_price * bookservice.units | currency:'EUR' }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>

      </ng-container>

      <div class="absolute bottom-[10px] left-[10px]">
        <button type="button"
          class="bg-blue-500 justify-center items-center text-white text-base h-14 w-56 sm:w-42 sm:h-14 disabled:cursor-not-allowed disabled:opacity-40 mr-1"
          (click)="showSaveDraft = true">Guardar borrador</button>
        <button type="button"
          class="bg-blue-500 justify-center items-center text-white text-base h-14 w-56 sm:w-42 sm:h-14 disabled:cursor-not-allowed disabled:opacity-40"
          (click)="onShowListDraft($event)">Recuperar borrador</button>
      </div>
    </div>
    <div class="col-span-12 lg:col-span-6 min-h-[300px]">
      <div class="xl:my-4 flex justify-center">
        <div class="flex flex-row ">
          <div class="focus-visible:ring" id="calculator-container">
            <div class=" bg-[#D9D9D9] border border-black  grid justify-center items-end pb-3 mb-2" id="display">
              <p class=" text-blue-800 font-extrabold text-3xl grid justify-center align-bottom sm:text-2xl"
                id="display-text">{{ this.display }}</p>
            </div>
            <div #calculator (keydown)="keyboardCalculator($event)" autoFocus
              class="grid grid-cols-4 gap-2 bg-[#D9D9D9] p-2 " id="calculator">
              <button (click)="reset()" class="bg-[#736f6f] text-white text-center text-2xl font-semibold"
                id="button-reset">C</button>
              <button (click)="backspace()" class="bg-[#736f6f] text-white text-center text-2xl font-semibold "
                id="button">⌫</button>
              <button (click)="oper('%')" class="bg-[#E79418] text-white text-center text-2xl font-semibold "
                id="button">%</button>
              <button (click)="oper('/')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">/</button>
              <button (click)="numClick('1')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">1</button>
              <button (click)="numClick('2')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">2</button>
              <button (click)="numClick('3')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">3</button>
              <button (click)="oper('*')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">*</button>
              <button (click)="numClick('4')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">4</button>
              <button (click)="numClick('5')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">5</button>
              <button (click)="numClick('6')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">6</button>
              <button (click)="oper('-')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">-</button>
              <button (click)="numClick('7')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">7</button>
              <button (click)="numClick('8')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">8</button>
              <button (click)="numClick('9')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">9</button>
              <button (click)="oper('+')" class="bg-[#E79418] text-white text-center text-4xl font-semibold "
                id="button">+</button>
              <button (click)="changeSign()" class="bg-[#736f6f] text-white text-center text-2xl font-semibold "
                id="button">+/-</button>
              <button (click)="numClick('0')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">0</button>
              <button (click)="numClick('.')" class="bg-[#1F1F1F] text-white text-center text-4xl font-semibold "
                id="button">,</button>
              <button (click)="calculate()" class="bg-[#736f6f] text-white text-center text-4xl font-semibold "
                id="button">=</button>
            </div>
          </div>
          <div class="grid grid-rows gap-2" id="buttons-container">
            <button
              class="{{ selectedPaymentType === 'EFECTIVO' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-blue-500 text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('EFECTIVO')">EFECTIVO</button>
            <button
              class="{{ selectedPaymentType === 'TARJETA' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-blue-600 text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('TARJETA')">TARJETA</button>
            <button
              class="{{ selectedPaymentType === 'BIZUM' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-blue-600 text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('BIZUM')">BIZUM</button>
            <button
              class="{{ selectedPaymentType === 'TRANSFERENCIA' ? 'border-slate-100 border-2 bg-[#E79418] text-white text-center text-xl font-semibold  p-5' : ' bg-black text-white text-center text-xl font-semibold  p-5' }}"
              id="button-pay" (click)="paymentType('TRANSFERENCIA')">TRANSFERENCIA</button>
          </div>
        </div>
        <div class="grid h-full gap-4" id="change">
          <div>
            <p class="grid justify-start text-[#27368A] font-bold">IMPORTE QUE RECIBES</p>
            <ng-container>
              <div>
                <input (focus)="validateZeroInput($event)" (keyup)="changeToReturn($event)" [(ngModel)]="putMoney"
                  #putMoneyInput type="text" placeholder="Introduce el importe"
                  class="h-16 w-96 sm:w-72  bg-[#D9D9D9] border border-black items-end p-2 text-white font-medium text-2xl grid justify-center align-bottom sm:h-10">
              </div>
            </ng-container>
          </div>
          <div>
            <p class="grid justify-start text-[#27368A] font-bold">CAMBIO A DEVOLVER</p>
            <p class="text-red-600 font-bold lg:text-6xl sm:text-4xl">{{ change + '€'}}</p>
          </div>
          <div class="grid items-end align-bottom">
            <button
              class="bg-red-500 justify-center items-center text-white text-xl uppercase font-bold h-24 w-96 sm:w-72 sm:h-24 mt-24 disabled:cursor-not-allowed disabled:opacity-40"
              (click)="resetCashierEntries()">resetear transacciones</button>
            <button
              class="bg-[#42BC18] justify-center items-center text-white uppercase text-xl font-bold h-24 w-96 sm:w-72 sm:h-24 disabled:cursor-not-allowed disabled:opacity-40"
              (click)="confirmEntry()" [disabled]="!selectedPaymentType || !allowConfirm">CONFIRMAR</button>
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-center items-center">
        <button
          class="bg-green-500 justify-center items-center text-white text-xl uppercase font-bold px-10 py-4 m-2 disabled:cursor-not-allowed disabled:opacity-40 w-[300px]"
          (click)="handleCashCashier(true)">Entrada de cambio</button>
        <button
          class="bg-red-500 justify-center items-center text-white text-xl uppercase font-bold px-10 py-4 m-2 disabled:cursor-not-allowed disabled:opacity-40 w-[300px]"
          (click)="handleCashCashier(false)">Salida de caja</button>
      </div>
    </div>

    <div class="col-span-12 lg:col-span-3 border-l-2 border-slate-500 p-3  min-h-[300px]">
      <div class="flex justify-between">
        <p class="font-extrabold text-xl ">Ticket a imprimir:</p>
        <span class="text-base font-bold">{{ totalSumTicket }}</span>
      </div>
      <hr class="mt-2 border-2">
      <div *ngIf="ticket !== undefined">
        <div *ngIf="ticket.details?.length === 0"
          class="flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer p-6 mb-4 mt-2">
          <h1 class="text-center text-xl text-slate-500">
            No hay cobros registrados<br>
            <small>Introduzca un importe</small>
          </h1>
        </div>
        <table *ngIf="ticket.details !== undefined && ticket.details.length > 0"
          class="w-full border-collapse border border-gray-200 text-left text-xs mt-2">
          <thead class="bg-gray-200">
            <tr>
              <th class="border border-gray-300 px-4 py-1 w-6">Concepto</th>
              <th class="border border-gray-300 px-4 py-1">Unidades</th>
              <th class="border border-gray-300 px-4 py-1">Subtotal</th>
              <th class="border border-gray-300 px-4 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detail of ticket.details; let i = index">
              <td class="border border-gray-300 px-4 py-1 truncate ...">
                {{ detail.concept }}
                <ng-container *ngIf="selectedBookings && detail.lock_units">
                  <button type="button" style="width: 30px; height: 30px;" class="bg-[#42BC18] rounded-md p-1"
                    pTooltip="Actividades" (click)="toggleActividades(detail.booking_id)" tooltipPosition="bottom">
                    <img src="/assets/icons/icon_coin.png" style="width: 30px; height: 20px;">
                  </button>
                </ng-container>
              </td>
              <td class="border border-gray-300 px-2 py-1 h-8">
                <div class="input-units justify-center">

                  <i *ngIf="!detail.lock_units ; else otherLess"
                    class="pi pi-minus-circle cursor-pointer hover:text-blue-500 justify-start"
                    (click)="decreaseUnits(i)"></i>
                  <ng-template #otherLess>
                    <i class="pi pi-minus-circle justify-start"></i>
                  </ng-template>
                  <input *ngIf="!detail.lock_units ; else otherInputTicket"
                    class="text-center text-sm w-9 hover:bg-slate-100 px-2" placeholder=""
                    [(ngModel)]="ticket.details[i].units" type="number" min="1" [value]="detail.units"
                    inputmode="numeric" pattern="[0-9]*" />
                  <ng-template #otherInputTicket>
                    <input class="text-center text-sm w-9 hover:bg-slate-100 px-2" placeholder=""
                      [(ngModel)]="ticket.details[i].units" readonly type="number" min="1" [value]="detail.units"
                      pattern="[0-9]*" />
                  </ng-template>
                  <i *ngIf="!detail.lock_units ; else otherPlus"
                    class="pi pi-plus-circle cursor-pointer hover:text-blue-500 justify-end"
                    (click)="increaseUnits(i)"></i>
                  <ng-template #otherPlus>
                    <i class="pi pi-plus-circle justify-start"></i>
                  </ng-template>
                </div>
              </td>
              <td class="border border-gray-300 px-4 py-1 text-base font-bold text-red-700 whitespace-nowrap">
                {{ detail.unit_price * detail.units | currency:'EUR'}}
              </td>
              <td
                class="border border-gray-300 px-4 py-1 text-sm font-bold text-red-700 cursor-pointer hover:text-red-400"
                (click)="deleteConcept(i)">
                Eliminar
              </td>
            </tr>

          </tbody>
        </table>
        <div *ngIf="ticket !== undefined && ticket.details !== undefined">

          <div *ngIf="ticket.details.length > 0" class="flex justify-between">
            <p class="text-sm ">{{ (isCashOutflow)? 'Salida de caja' : 'Restante a cobrar' }}:</p>
            <span class="text-base font-bold">{{ totalRestanteTickets }}</span>
          </div>
        </div>
      </div>
      <div class="grid justify-center items-end align-bottom fixed bottom-4 right-4 col-span-3">
        <button
          class="bg-[#27368A] justify-center items-center text-white text-xl font-bold w-[450px] h-32 sm:h-24  disabled:cursor-not-allowed disabled:opacity-40"
          (click)="printTicket()" [disabled]="!confirmedEntry">FINALIZAR</button>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Selecciona la talla" [(visible)]="showSizes" [modal]="true" [style]="{width: '20vw'}"
  *ngIf="billables.length > 0">
  <p>{{this.billables[viewSelectedSizes][0].name}}</p>
  <div class="flex flex-col gap-3">
    <div *ngFor="let item of this.billables[viewSelectedSizes]; let i = index;">
      <div class="flex flex-row gap-2">
        <input (click)="confirmBillableSize(i)" type="radio" value="size" [(ngModel)]="size">
        <label [for]="item.size">{{ item.size }}</label>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="Añadir Otros" [(visible)]="showOther" [modal]="true" [style]="{width: '20vw'}">
  <div class="flex flex-col gap-3">
    <div class="flex flex-row gap-2 align-middle justify-between">
      <label for="concept">Concepto</label>
      <input type="text" [(ngModel)]="otherDetail.concept" class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-52">
    </div>
    <div class="flex flex-row gap-2 align-middle justify-between">
      <label>Precio und.</label>
      <input type="number" [(ngModel)]="otherDetail.unitPrice" min="0"
        class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-52">
    </div>
  </div>
  <div class="flex justify-end">
    <button
      class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
      (click)="confirmOthers()" [disabled]="otherDetail.unitPrice === 0 || !otherDetail.concept">Añadir</button>
  </div>
</p-dialog>

<p-dialog header="Cobrar importe de reserva" [(visible)]="showBooking" [modal]="true"
  [style]="{width: '90%', maxWidth: '400px', minHeight: '400px'}">
  <div class="flex flex-col gap-3">
    <div class="flex flex-row gap-2 align-middle justify-between">
      <label for="concept" class="w-[160px]">Buscar reserva</label>
      <!-- <input type="text" [(ngModel)]="inputSearchBooking" (blur)="searchBooking($event)"
        class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full"> -->
      <p-autoComplete #searcherAutocomplete [suggestions]="results_bookings" [showClear]="true" class="block w-full"
        [virtualScrollItemSize]="40" (completeMethod)="searchBooking($event)" (onSelect)="onSelectBooking($event)"
        styleClass="block w-full" field="reference" [(ngModel)]="selectedBooking"
        inputStyleClass="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 w-full px-2 mb-2 "
        placeholder="Buscar reserva" [delay]="500">
        <ng-template let-item pTemplate="itemTemplate">
          <div class="autocomplete-item">
            <h3>{{item.reference}}</h3>
            <span class="block text-xs text-gray-700">Cliente: {{item.customer?.name}}</span>
            <span class="block text-xs text-gray-700">CIF: {{item.customer?.cif}}</span>
            <span class="block text-xs text-gray-700">Total: {{item.total_amount}}</span>
            <span class="block text-xs text-gray-700">Faltante: {{(item.total_amount - item.total_paid)}}</span>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <ng-container *ngIf="selectedBooking && selectedBooking.reference">
      <div class=" gap-2 align-middle justify-between">
        <label for="total_amount" class="w-full block">Monto total</label>
        <input id="total_amount" type="text" [(ngModel)]="totalAmountBooking" pattern="[0-9]*" readonly
          class="bg-[#F3F3F3] block  py-1 px-2 w-full">
      </div>
      <div class=" gap-2 align-middle justify-between">
        <label for="total_amount" class="w-full block">Monto restante a pagar</label>
        <input id="total_amount" type="text" [(ngModel)]="totalToPayAmountBooking" pattern="[0-9]*" readonly
          class="bg-[#F3F3F3] block py-1 px-2 w-full">
      </div>
      <div class=" gap-2 align-middle justify-between mb-[20px]">
        <label for="total_amount" class="w-full block">Importe</label>
        <input (focus)="(cashAmountBooking == 0)? cashAmountBooking = '' : cashAmountBooking = cashAmountBooking;"
          id="total_amount" type="text" [(ngModel)]="cashAmountBooking" (keydown)="utils.onlyNumbersFloatWhitNegative($event)"
          class="bg-[#F3F3F3] block  py-1 px-2 w-full">
      </div>
    </ng-container>


  </div>
  <div class="flex justify-end" *ngIf="selectedBooking && selectedBooking.reference">
    <button
      class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
      (click)="confirmBookingCash()"
      [disabled]="validateAddImportBooking()">
      Añadir
    </button>
  </div>
</p-dialog>

<p-dialog header="Guardar borrador" [(visible)]="showSaveDraft" [modal]="true"
  [style]="{width: '90%', maxWidth: '500px'}">
  <div class="flex flex-col gap-3">
    <div class="flex flex-row gap-2 align-middle justify-between">
      <label for="total_amount" class="w-[160px]">Alias</label>
      <input type="text" [(ngModel)]="nameAlias" class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full">
    </div>

  </div>
  <div class="flex justify-end">
    <button
      class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
      (click)="saveDraft($event)" [disabled]="nameAlias.trim() == ''">Guardar</button>
  </div>
</p-dialog>



<p-dialog header="Lista de borradores de tickets" [(visible)]="showListDraft" [modal]="true"
  [style]="{width: '90%', maxWidth: '500px'}">
  <div class="flex flex-col gap-3">
    <div class="flex flex-row gap-2 align-middle justify-between">
      <div class="card flex justify-content-center w-full p-listbox-container">
        <p-listbox [options]="ticketsDraft" [(ngModel)]="selectedTicketDraft" optionLabel="alias"
          [style]="{'width': '100%'}" [id]="'list-tickets-draft'" (onClick)="onSelectTicketDraft($event)"
          [filter]="true" [listStyle]="{'max-height': '220px'}"></p-listbox>
      </div>
    </div>

  </div>
  <div class="flex justify-end">
    <!-- <button
      class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="nameAlias.trim() == ''">Guardar</button> -->
  </div>
</p-dialog>

<p-confirmDialog #cd [style]="{ width: '95%', maxWidth: '400px' }">
  <ng-template pTemplate="header">
    <h3 class="border-b border-gray-300 w-full pb-2 text-lg">{{ isCashIn ? 'Va a insertar cambio a caja' : 'Va a pagar por caja' }}</h3>
  </ng-template>
  <ng-template pTemplate="icon">
  </ng-template>
  <ng-template pTemplate="message">
    <ng-container *ngIf="isCashIn">
      <section class="flex justify-center w-full">
        <div>
          <p class="block ">Indique la cantidad</p>
          <input class="flex align-middle w-full bg-[#f0f0f0] px-3 py-2 rounded-[10px] h-10" appOnlyNumbersFloat
            appValidateZeroInput (focus)="validateZeroInput($event)" type="text" placeholder="Importe..."
            [(ngModel)]="cashAmount">
        </div>
      </section>
    </ng-container>
    <ng-container *ngIf="!isCashIn">
      <section class="flex justify-center w-full">
        <div>
          <p class="block ">Indique la cantidad</p>
          <input class="flex align-middle w-full bg-[#f0f0f0] px-3 py-2 rounded-[10px] h-10" appOnlyNumbersNegativeFloat
            appValidateZeroInput (focus)="validateZeroInput($event)" type="text" placeholder="Importe..."
            [(ngModel)]="cashAmount">
        </div>
      </section>
    </ng-container>

  </ng-template>
  <ng-template pTemplate="footer">
    <button class="bg-red-600 justify-center items-center text-white text-normal rounded-xl py-1 px-4 mr-1"
      type="button" pButton label="No" (click)="cd.reject()"></button>
    <button class="bg-green-600 justify-center items-center text-white text-normal rounded-xl py-1 px-4" type="button"
      pButton label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-toast></p-toast>
